import { graphql } from "./generated/gql";

export const ChangeInterviewerMutation = graphql(`
  mutation ChangeInterviewer($input: ChangeInterviewerInput!) {
    changeInterviewer(input: $input) {
      success
      interview {
        interviewId
        interviewerId
        interviewerName
        interviewerEmail
        zoomMeetingId
        zoomMeetingUrl
      }
      errorMessage
    }
  }
`);

export const CancelInterviewMutation = graphql(`
  mutation CancelInterview($interviewId: ID!) {
    cancelInterview(interviewId: $interviewId) {
      interviewId
      status
    }
  }
`);

export const AdminInterviewDetailQuery = graphql(`
  query AdminInterviewDetail($interviewId: ID!) {
    interview(interviewId: $interviewId) {
      interviewId
      candidateName
      candidateEmail
      sponsorName
      termTitle
      interviewerName
      startTime
      endTime
      status
      stakeholderContext {
        stakeholderSettingName
        recipientNames
        answersImported
      }
      rawVttText
      zoomRecordingViewUrl
    }
  }
`);

export const AdminInterviewForSummaryCheckQuery = graphql(`
  query AdminInterviewForSummaryCheck($interviewId: ID!) {
    interview(interviewId: $interviewId) {
      interviewId
      candidateName
      sponsorName
      termTitle
      stakeholderContext {
        stakeholderSettingName
        recipientNames
        answersImported
      }
      rawVttText
      zoomRecordingViewUrl
      completionReport {
        completionReportId
        satisfactionScore
        behaviorChangeScore
      }
    }
  }
`);

export const InterviewScriptItemsQuery = graphql(`
  query InterviewScriptItems($interviewId: ID!) {
    interviewScriptItems(interviewId: $interviewId) {
      nodes {
        scriptItemId
        scriptId
        category
        timeEstimate
        itemName
        isRequired
        question
        answer
        memo
        note
        order
        orderIndex
        createdAt
        updatedAt
      }
      totalCount
    }
  }
`);

export const InterviewsQuery = graphql(`
  query Interviews {
    interviews {
      nodes {
        interviewId
        candidateId
        interviewerId
        startTime
        endTime
        zoomMeetingId
        zoomMeetingUrl
        zoomRecordingViewUrl
        candidateName
        candidateEmail
        stakeholderContext {
          stakeholderSettingName
          recipientNames
          answersImported
        }
        status
        summaryCheckCompletedAt
        completionReport {
          completionReportId
          handoverNote
          coachReportNg
          interviewerInsight
          internalUseAllowed
          hasConfidentialInfo
          confidentialInfo
          satisfactionScore
          behaviorChangeScore
          completedAt
        }
        createdAt
        updatedAt
        interviewerName
        interviewerEmail
        termId
        termTitle
        sponsorId
        sponsorName
      }
      totalCount
    }
  }
`);

export const TermInterviewsQuery = graphql(`
  query TermInterviews($termId: ID!) {
    termInterviews(termId: $termId) {
      nodes {
        interviewId
        candidateId
        interviewerId
        startTime
        endTime
        zoomMeetingId
        zoomMeetingUrl
        zoomRecordingViewUrl
        candidateName
        candidateEmail
        stakeholderContext {
          stakeholderSettingName
          recipientNames
          answersImported
        }
        status
        summaryCheckCompletedAt
        completionReport {
          completionReportId
          handoverNote
          coachReportNg
          interviewerInsight
          internalUseAllowed
          hasConfidentialInfo
          confidentialInfo
          satisfactionScore
          behaviorChangeScore
          completedAt
        }
        createdAt
        updatedAt
        interviewerName
        interviewerEmail
        termId
        termTitle
        sponsorId
        sponsorName
      }
      totalCount
    }
  }
`);
